/* eslint-disable react/display-name */

// @ts-expect-error module not typed
import ReassignmentValueButton from '../components/ReassignmentValueButton';
import { AWAY } from '../constants/agent-state';
import { getAgentState, getAvatarUrl, getEmail, getFirstName, getLastName, isBot } from './assignees';
import { jsx as _jsx } from "react/jsx-runtime";
export const currentAssigneeValueRenderer = ({
  AsyncUIAvatar,
  currentAssignee,
  loadingAssignee
}) => ({
  text
}) => {
  const DEFAULT_BOT_NAME = 'HubBot';
  return /*#__PURE__*/_jsx(ReassignmentValueButton, {
    AsyncUIAvatar: AsyncUIAvatar,
    avatar: getAvatarUrl(currentAssignee),
    away: getAgentState(currentAssignee) === AWAY,
    email: getEmail(currentAssignee),
    firstName: isBot(currentAssignee) ? DEFAULT_BOT_NAME : getFirstName(currentAssignee),
    lastName: getLastName(currentAssignee),
    loading: loadingAssignee,
    text: text,
    responder: currentAssignee
  });
};